import { render, staticRenderFns } from "./SingleSelectFirma.vue?vue&type=template&id=cf460e18&"
import script from "./SingleSelectFirma.vue?vue&type=script&lang=js&"
export * from "./SingleSelectFirma.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports